/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SmsTemplateDtoBase
 * auto generated base class for the model SmsTemplateDtoModel.
 */
export const SmsTemplateDtoModelBase = ModelBase
  .named('SmsTemplateDto')
  .props({
    __typename: types.optional(types.literal("SmsTemplateDto"), "SmsTemplateDto"),
    body: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SmsTemplateDtoModelSelector extends QueryBuilder {
  get body() { return this.__attr(`body`) }
}
export function selectFromSmsTemplateDto() {
  return new SmsTemplateDtoModelSelector()
}

export const smsTemplateDtoModelPrimitives = selectFromSmsTemplateDto().body
